//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import { faBook } from '@fortawesome/pro-regular-svg-icons';
import productPreviewModeMixin from '@motionelements/product2025/src/mixins/product-preview-mode.mixin.js';
import PreviewModeBlock from '@motionelements/product2025/src/sections/PreviewModeBlock.vue';
import { filterObj } from '@/helpers/object.js';

import 'swiper/swiper-bundle.css';

export default {
  name: 'ProductPageLayout',
  components: {
    PreviewModeBlock,
    ProductCtaBlock: () => import('@motionelements/product2025/src/sections/ProductCtaBlock.vue'),
    SecondaryCtaButtons: () => import('@motionelements/product2025/src/sections/SecondaryCtaButtons.vue'),
    AiToolsSidebar: () => import('@motionelements/product2025/src/sections/AiToolsSidebar.vue'),
    ArchiveEntries: () => import('@motionelements/product2025/src/sections/ArchiveEntries.vue'),
    ProductStillsSection: () => import('@motionelements/product2025/src/sections/ProductStillsSection.vue'),
    ProductAttributes: () => import('@motionelements/product2025/src/sections/ProductAttributes.vue'),
    ProductRecommendations: () => import('@motionelements/catalog/src/modules/product/sections/recommendations/ProductRecommendationsFullWidth.vue'),
    ProductDescriptionAndKeywords: () => import('@motionelements/product2025/src/components/ProductDescriptionAndKeywords.vue'),
    ProductPreview: () => import('@motionelements/product2025/src/sections/ProductPreview.vue'),
    ProductStems: () => import('@motionelements/product2025/src/sections/ProductStems.vue'),
    ProductContributor: () => import('@motionelements/product2025/src/components/ProductContributor.vue'),
    ProductCtaButtonsMobile: () => import('@motionelements/product2025/src/components/ProductCtaButtonsMobile.vue'),
    FlagProductModal: () => import('@motionelements/product2025/src/modals/FlagProductModal.vue'),
    ProductAttributesMobile: () => import('@motionelements/product2025/src/components/ProductAttributesMobile.vue'),
    ShareProductModal: () => import('@motionelements/product2025/src/modals/ShareProductModal.vue'),
    CollapsiblePanel: () => import('@motionelements/product2025/src/components/CollapsiblePanel.vue'),
    TutorialPdfViewer: () => import('@motionelements/product2025/src/components/TutorialPdfViewer.vue'),
    //
    ProductCtaButtonsMobileMenu: () => import('@motionelements/product2025/src/components/ProductCtaButtonsMobileMenu.vue'),
  },
  mixins: [productPreviewModeMixin],
  inject: {
    isPopUp: {
      default: false,
    },
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    archiveEntries: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      productAttributesMobileCollapsed: true,
      faBook,
    };
  },
  computed: {
    ...mapState({
      member: state => state.user.member,
      isLoggedIn: state => state.user.isLoggedIn,
      overlayShown: state => state.app.overlayShown,
      ctaMobileMenuShown: state => state.app.ctaMobileMenuShown,
    }),
    ...mapGetters({
      mediaType: 'product/mediaType',
      isMobile: 'browser/isMobile',
      videoTutorialGetter: 'product/videoTutorial',
      pdfTutorialGetter: 'product/pdfTutorial',
    }),
    tutorialVideoUrl() {
      const tutorial = this.videoTutorialGetter(this.product);
      return _.get(tutorial, 'url') || null;
    },
    tutorialPdfUrl() {
      const tutorial = this.pdfTutorialGetter(this.product);
      return _.get(tutorial, 'url') || null;
    },
    showAiTools() {
      return true;
    },
    isOwner() {
      return this.isLoggedIn
        && this.member.artist
        && this.member.username
        && this.member.username === _.get(this.product, 'artist.username');
    },
  },
  methods: {
    contributor() {
      return this.product?.artist && filterObj(this.product.artist, ['html', 'avatar', 'gravatar', 'username']);
    },
    addStemsToCart(stemsIds) {
      console.log('======== addStemsToCart ', stemsIds);
    },
    scrollToAttributes() {
      const productAttributesElement = this.isMobile ? this.$refs.productAttributesMobile.$el : this.$refs.productAttributes.$el;
      if (productAttributesElement) {
        this.productAttributesMobileCollapsed = false;
        productAttributesElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
    handleProductAttributesMobileCollapsed(collapsed) {
      this.productAttributesMobileCollapsed = !collapsed;
    },
    hideOverlay() {
      this.$store.commit('app/toggleOverlay', false);
      this.$bus.$emit('b-overlay:hidden');
      this.$store.commit('app/toggleCtaMobileMenu', false);
    },
  },
};
